import { RouteConfig } from 'vue-router'
import {requireAuth} from '../auth'
import { templateLibraryAdminRoutes } from '../constants/agency/'

const TemplateLibraryAdmin = () =>
  import(
    // @ts-ignore: Unable to resolve module in local dev
    /* webpackChunkName: "template-library-admin" */ '@/pmd/pages/template_library/TemplateLibraryAdmin.vue'
  )

const TemplateLibraryPublicContext = () =>
  import(
    // @ts-ignore: Unable to resolve module in local dev
    /* webpackChunkName: "template-library-public-context" */ '@/pmd/pages/template_library/PublicContextHandler.vue'
  )

const TemplateLibraryPublic = () =>
  import(
    // @ts-ignore: Unable to resolve module in local dev
    /* webpackChunkName: "template-library-public" */ '@/pmd/pages/template_library/TemplateLibraryPublic.vue'
  )

export const templateLibraryAdmin:RouteConfig[] = [
  {
    path: '/template-library-admin',
    name: templateLibraryAdminRoutes.default,
    component: TemplateLibraryAdmin,
    beforeEnter: requireAuth,
  },
  {
    path: '/template-library-public-context',
    name: templateLibraryAdminRoutes.publicContext,
    component: TemplateLibraryPublicContext,
    beforeEnter: requireAuth,
  },
  {
    path: '/template-library-public',
    name: templateLibraryAdminRoutes.public,
    component: TemplateLibraryPublic,
  },
]
